import EntityListItem from '@/components/EntityListItem/EntityListItem';
import { useAgents } from '@/models/agents';
import { useLocation } from 'wouter';

export default function AgentList() {
  const { data: agents, isLoading } = useAgents();

  const [loc, nav] = useLocation();

  if (isLoading) {
    return <>...</>;
  }

  return agents?.map((a) => (
    <EntityListItem
      onClick={() => {
        nav(`/${a.id}`, { state: { agent: a } });
      }}
      p={'xs'}
      key={a.id}
      topRow={a.name}
      selected={loc === `/${a.id}` || loc.startsWith(`/${a.id}/`)}
    />
  ));
}
